/* TODO 콘진원만 넣어야해 */
const OVERSEA_CREW_IDS = [595];
export const isPossibleOverseaByCrewId = (crew_id) => {
  return OVERSEA_CREW_IDS.includes(crew_id);
};
